var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaunch3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32.381,
    height: 32.381,
    rx: 16.1905,
    fill: "#D7F9FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9405 11.8164C14.9405 10.0905 13.5414 8.69141 11.8155 8.69141C10.0896 8.69141 8.69048 10.0905 8.69048 11.8164C8.69048 13.5423 10.0896 14.9414 11.8155 14.9414C13.5414 14.9414 14.9405 13.5423 14.9405 11.8164Z",
    stroke: "#007E8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6905 20.5664C23.6905 18.8405 22.2914 17.4414 20.5655 17.4414C18.8396 17.4414 17.4405 18.8405 17.4405 20.5664C17.4405 22.2923 18.8396 23.6914 20.5655 23.6914C22.2914 23.6914 23.6905 22.2923 23.6905 20.5664Z",
    stroke: "#007E8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9405 20.5664C14.9405 18.8405 13.5414 17.4414 11.8155 17.4414C10.0896 17.4414 8.69048 18.8405 8.69048 20.5664C8.69048 22.2923 10.0896 23.6914 11.8155 23.6914C13.5414 23.6914 14.9405 22.2923 14.9405 20.5664Z",
    stroke: "#007E8C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4311 9.4697L22.9122 8.95084C22.5663 8.60493 22.0055 8.60493 21.6596 8.95083L18.8689 11.7415C18.498 12.1124 18.2451 12.5849 18.1422 13.0993L17.8571 14.5247L19.2826 14.2396C19.797 14.1368 20.2695 13.8839 20.6404 13.513L23.4311 10.7223C23.777 10.3764 23.777 9.8156 23.4311 9.4697Z",
    stroke: "#007E8C",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunch3);
export default __webpack_public_path__ + "static/media/launch-3.a22d6d294dede6bfda4e1c9e21486d3a.svg";
export { ForwardRef as ReactComponent };